import React from 'react';
import { Link as ScrollLink } from 'react-scroll';
import { products } from '../../data/products';
import './LabHero.scss';

const LINES = ['WE BUILD', "WHAT'S", 'NEXT.'];

const LabHero = () => {
    const live = products.filter((p) => p.status === 'LIVE').length;

    return (
        <section className="lab-hero" id="hero">
            <div className="lab-hero-grid" aria-hidden="true" />
            <div className="lab-hero-glow" aria-hidden="true" />

            <div className="lab-hero-inner">
                <div className="lab-hero-eyebrow">
                    <span className="lab-hero-dot" aria-hidden="true" />
                    Evolve Labs
                    <span className="lab-hero-sep" aria-hidden="true">/</span>
                    Product Company &amp; Technology Lab
                </div>

                <h1 className="lab-hero-title">
                    {LINES.map((line, i) => (
                        <span className="lab-hero-line" key={line}>
                            <span className="lab-hero-line-in" style={{ '--i': i }}>
                                {line}
                            </span>
                        </span>
                    ))}
                </h1>

                <div className="lab-hero-base">
                    <p className="lab-hero-copy">
                        Evolve Labs creates and develops software products across AI, developer
                        tools, gaming, communication, productivity, and emerging technology.
                    </p>

                    <div className="lab-hero-actions">
                        <ScrollLink
                            to="products"
                            smooth
                            duration={700}
                            offset={-70}
                            className="lab-hero-cta"
                        >
                            Explore Products
                            <span className="lab-hero-cta-arrow" aria-hidden="true">↓</span>
                        </ScrollLink>

                        <ScrollLink
                            to="about"
                            smooth
                            duration={700}
                            offset={-70}
                            className="lab-hero-secondary"
                        >
                            About the Lab
                        </ScrollLink>
                    </div>
                </div>

                <dl className="lab-hero-stats">
                    <div>
                        <dt>Products</dt>
                        <dd>{String(products.length).padStart(2, '0')}</dd>
                    </div>
                    <div>
                        <dt>Live</dt>
                        <dd>{String(live).padStart(2, '0')}</dd>
                    </div>
                    <div>
                        <dt>Base</dt>
                        <dd>Detroit</dd>
                    </div>
                </dl>
            </div>
        </section>
    );
};

export default LabHero;
